import { render, staticRenderFns } from "./LoanTable.vue?vue&type=template&id=1236e28a"
import script from "./LoanTable.vue?vue&type=script&lang=js"
export * from "./LoanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports